import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { DenominationListProps } from '@features/payment/payment-form'
import { getSingleTspType, TspType } from '@entities/tsp'
import GameDenominationListWithCategoryPicker from './GameDenominationListWithCategoryPicker'
import ServiceDenominationListWithCountryPicker from './ServiceDenominationListWithCountryPicker'

const DynamicServiceDenominationListWithCountryPicker = dynamic(
  () => import('./ServiceDenominationListWithCountryPicker').then((imported) => imported.default),
  {
    ssr: false,
  }
)

const DynamicGameDenominationListWithCategoryPicker = dynamic(
  () => import('./GameDenominationListWithCategoryPicker').then((imported) => imported.default),
  {
    ssr: false,
  }
)

const DenominationListWithPicker: FC<DenominationListProps> = ({
  payee,
  countryVouchers,
  denominationsByCountry,
  pricesByServiceId,
}) => {
  const type = getSingleTspType(payee)

  switch (type) {
    case TspType.GAMES:
      return (
        <GameDenominationListWithCategoryPicker
          payee={payee}
          denominations={denominationsByCountry}
          pricesByServiceId={pricesByServiceId}
        />
      )
    case TspType.SERVICES:
      return (
        <ServiceDenominationListWithCountryPicker
          payee={payee}
          countries={countryVouchers}
          denominationsByCountry={denominationsByCountry}
          pricesByServiceId={pricesByServiceId}
        />
      )
    // добавить для ключей
    default:
      return (
        <ServiceDenominationListWithCountryPicker
          payee={payee}
          countries={countryVouchers}
          denominationsByCountry={denominationsByCountry}
          pricesByServiceId={pricesByServiceId}
        />
      )
  }
}

export default DenominationListWithPicker
